import { all, takeLatest, put, call } from 'redux-saga/effects';
import { request } from "../../utils/http";
import {
    GET_INVEST_ACCOUNT_REQUEST,
    GET_INVEST_ACCOUNT_SUCCESS,
    GET_INVEST_ACCOUNT_ERROR,
    INVEST_ACCOUNT_CREATE_REQUEST,
    INVEST_ACCOUNT_CREATE_SUCCESS,
    INVEST_ACCOUNT_CREATE_ERROR,
    INVEST_ACCOUNT_PATCH_REQUEST,
    INVEST_ACCOUNT_PATCH_SUCCESS,
    INVEST_ACCOUNT_PATCH_ERROR,
    INVEST_ACCOUNT_POST_REQUEST,
    INVEST_ACCOUNT_POST_SUCCESS,
    INVEST_ACCOUNT_POST_ERROR,
    INVEST_ACCOUNT_DOCUMENT_UPLOAD_REQUEST,
    INVEST_ACCOUNT_DOCUMENT_UPLOAD_SUCCESS,
    INVEST_ACCOUNT_DOCUMENT_UPLOAD_ERROR,
    PLAID_INTEGRATION_REQUEST,
    PLAID_INTEGRATION_SUCCESS,
    PLAID_INTEGRATION_ERROR,
    GET_PLAID_ACCOUNTS_REQUEST,
    GET_PLAID_ACCOUNTS_SUCCESS,
    GET_PLAID_ACCOUNTS_ERROR,
    PLAID_FUND_TRANSFER_REQUEST,
    PLAID_FUND_TRANSFER_SUCCESS,
    PLAID_FUND_TRANSFER_ERROR,
    RECURRING_DEPOSIT_REQUEST,
    RECURRING_DEPOSIT_SUCCESS,
    RECURRING_DEPOSIT_ERROR,
    REFER_FRIEND_REQUEST,
    REFER_FRIEND_SUCCESS,
    REFER_FRIEND_ERROR,
    GET_GOOGLE_CONTACTS_REQUEST,
    GET_GOOGLE_CONTACTS_SUCCESS,
    GET_GOOGLE_CONTACTS_ERROR,
    SET_ACCOUNT_INDICATOR,
} from "../reducers/AccountReducer";
import { getSimplifiedError } from "../../utils/error";
import { convertToFormData } from "../../utils/http";

function createInvestAccount(payload) {
    return request.post('/account/invest/', payload);
}

function* handleCreateInvestAccount(action) {
    try {
        const { payload, callback } = action;
        const { status, data } = yield call(createInvestAccount, payload);

        if (status === 201) {
            yield put({
                type: INVEST_ACCOUNT_CREATE_SUCCESS,
                account: data.data[0],
            });
            if (data.account_indicator) {
                yield put({
                    type: SET_ACCOUNT_INDICATOR,
                    account: data.account_indicator,
                    progressbar: data.progress
                });
            }
            callback();
        } else {
            yield put({
                type: INVEST_ACCOUNT_CREATE_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('account create error :', error.response);
        yield put({
            type: INVEST_ACCOUNT_CREATE_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function patchInvestAccount(payload) {
    const id = payload.id;
    delete payload.id;
    return request.patch(`/account/invest/${id}/`, payload);
}

function* handlePatchInvestAccount(action) {
    try {
        const { payload, callback } = action;
        const { status, data } = yield call(patchInvestAccount, payload);

        if (status === 200) {
            yield put({
                type: INVEST_ACCOUNT_PATCH_SUCCESS,
                account: data.data[0],
                accountIndicator: data.account_indicator,
                progressbar: data.progress
            });
            callback();
        } else {
            yield put({
                type: INVEST_ACCOUNT_PATCH_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('account patch error :', error.response);
        yield put({
            type: INVEST_ACCOUNT_PATCH_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function postInvestAccount(payload) {
    const id = payload.id;
    delete payload.id;
    return request.post(`/account/invest/${id}/progress/`, payload);
}

function* handlePostInvestAccount(action) {
    try {
        const { payload, callback } = action;
        const { status, data } = yield call(postInvestAccount, payload);

        if (status === 200) {
            yield put({
                type: INVEST_ACCOUNT_POST_SUCCESS,
                account: data.data[0],
                accountIndicator: data.account_indicator,
                progressbar: data.progress
            });
            callback();
        } else {
            yield put({
                type: INVEST_ACCOUNT_POST_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('account patch error :', error.response);
        yield put({
            type: INVEST_ACCOUNT_POST_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function documentUploadForInvestAccount(payload) {
    payload = convertToFormData(payload);
    return request.post(`/document_upload/`, payload);
}

function* handleDocumentUploadForInvestAccount(action) {
    try {
        const { payload, callback } = action;
        const { status, data } = yield call(documentUploadForInvestAccount, payload);

        if (status === 200) {
            yield put({
                type: INVEST_ACCOUNT_DOCUMENT_UPLOAD_SUCCESS,
            });
            callback(data);
        } else {
            yield put({
                type: INVEST_ACCOUNT_DOCUMENT_UPLOAD_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('document upload for invest account error :', error.response);
        yield put({
            type: INVEST_ACCOUNT_DOCUMENT_UPLOAD_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function integratePlaid(payload) {
    return request.post(`/plaid/link/`, payload);
}

function* handleIntegratePlaid(action) {
    try {
        const { payload, callback } = action;
        const { status } = yield call(integratePlaid, payload);

        if (status === 200) {
            yield put({
                type: PLAID_INTEGRATION_SUCCESS,
            });
            callback();
        } else {
            yield put({
                type: PLAID_INTEGRATION_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('plaid integration error :', error.response);
        yield put({
            type: PLAID_INTEGRATION_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function getPlaidAccounts(payload) {
    return request.get(`/plaid/fund/?invest_id=${payload.id}`);
}

function* handleGetPlaidAccounts(action) {
    try {
        const { payload, callback } = action;
        const { status, data } = yield call(getPlaidAccounts, payload);

        if (status === 200) {
            yield put({
                type: GET_PLAID_ACCOUNTS_SUCCESS,
                accounts: data.data
            });
            if (callback) {
                callback();
            }

        } else {
            yield put({
                type: GET_PLAID_ACCOUNTS_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('get plaid accounts error :', error.response);
        yield put({
            type: GET_PLAID_ACCOUNTS_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function plaidFundTransfer(payload) {
    return request.post(`/plaid/fund/`, payload);
}

function* handlePlaidFundTransfer(action) {
    try {
        const { payload } = action;
        const { status } = yield call(plaidFundTransfer, payload);

        if (status === 200) {
            yield put({
                type: PLAID_FUND_TRANSFER_SUCCESS,
            });
        } else {
            yield put({
                type: PLAID_FUND_TRANSFER_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('plaid fund transfer error :', error.response);
        yield put({
            type: PLAID_FUND_TRANSFER_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function recurringDeposit(payload) {
    return request.post(`/plaid/recurring-deposit/`, payload);
}

function* handleRecurringDeposit(action) {
    try {
        const { payload } = action;
        const { status } = yield call(recurringDeposit, payload);

        if (status === 200) {
            yield put({
                type: RECURRING_DEPOSIT_SUCCESS,
            });
        } else {
            yield put({
                type: RECURRING_DEPOSIT_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('recurring deposit error :', error.response);
        yield put({
            type: RECURRING_DEPOSIT_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function getInvestAccount(payload) {
    return request.get(`/account/invest/${payload.id}/`);
}

function* handleGetInvestAccount(action) {
    try {
        const { payload } = action;
        const { status, data } = yield call(getInvestAccount, payload);

        if (status === 200) {
            yield put({
                type: GET_INVEST_ACCOUNT_SUCCESS,
                account: data.myra_investment_account,
                accountIndicator: data.account_indicator,
                progressbar: data.progress
            });

        } else {
            yield put({
                type: GET_INVEST_ACCOUNT_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('get invest account error :', error.response);
        yield put({
            type: GET_INVEST_ACCOUNT_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function referFriend(payload) {
    return request.post(`/refer-friend/`, payload);
}

function* handleReferFriend(action) {
    try {
        const { payload } = action;
        const { status } = yield call(referFriend, payload);

        if (status === 200) {
            yield put({
                type: REFER_FRIEND_SUCCESS,
            });

        } else {
            yield put({
                type: REFER_FRIEND_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('refer friend error :', error.response);
        yield put({
            type: REFER_FRIEND_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

function getGoogleContacts(payload) {
    return request.post('/get-google-contacts/', payload);
}

function* handleGetGoogleContacts(action) {
    try {
        const { payload } = action;
        const { status, data } = yield call(getGoogleContacts, payload);

        if (status === 200) {
            yield put({
                type: GET_GOOGLE_CONTACTS_SUCCESS,
                contacts: data.data
            });

        } else {
            yield put({
                type: GET_GOOGLE_CONTACTS_ERROR,
                error: 'Something went wrong, Please try again later',
            });
        }
    } catch (error) {
        console.log('get google contacts error :', error.response);
        yield put({
            type: GET_GOOGLE_CONTACTS_ERROR,
            error: getSimplifiedError(error) || 'Something went wrong, Please try again later',
        });
    }
}

export default all([
    takeLatest(INVEST_ACCOUNT_CREATE_REQUEST, handleCreateInvestAccount),
    takeLatest(INVEST_ACCOUNT_PATCH_REQUEST, handlePatchInvestAccount),
    takeLatest(INVEST_ACCOUNT_POST_REQUEST, handlePostInvestAccount),
    takeLatest(INVEST_ACCOUNT_DOCUMENT_UPLOAD_REQUEST, handleDocumentUploadForInvestAccount),
    takeLatest(PLAID_INTEGRATION_REQUEST, handleIntegratePlaid),
    takeLatest(GET_PLAID_ACCOUNTS_REQUEST, handleGetPlaidAccounts),
    takeLatest(PLAID_FUND_TRANSFER_REQUEST, handlePlaidFundTransfer),
    takeLatest(RECURRING_DEPOSIT_REQUEST, handleRecurringDeposit),
    takeLatest(GET_INVEST_ACCOUNT_REQUEST, handleGetInvestAccount),
    takeLatest(REFER_FRIEND_REQUEST, handleReferFriend),
    takeLatest(GET_GOOGLE_CONTACTS_REQUEST, handleGetGoogleContacts)
]);
